import React from 'react';
import './styles/skeletonloader.css';

interface SkeletonLoaderProps {
  type?: 'text' | 'card' | 'input' | 'button' | 'avatar' | 'line';
  width?: string;
  height?: string;
  count?: number;
  className?: string;
}

export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  type = 'text',
  width = '100%',
  height = '20px',
  count = 1,
  className = '',
}) => {
  const skeletons = Array.from({ length: count });

  return (
    <>
      {skeletons.map((_, index) => (
        <div
          key={index}
          className={`skeleton skeleton--${type} ${className}`}
          style={{
            width,
            height,
          }}
        />
      ))}
    </>
  );
};

export const SkeletonCard: React.FC<{ count?: number }> = ({ count = 1 }) => {
  const cards = Array.from({ length: count });

  return (
    <>
      {cards.map((_, index) => (
        <div key={index} className="skeleton-card">
          <SkeletonLoader type="avatar" width="48px" height="48px" />
          <div className="skeleton-card__content">
            <SkeletonLoader type="text" width="60%" height="16px" />
            <SkeletonLoader type="text" width="80%" height="14px" />
          </div>
        </div>
      ))}
    </>
  );
};

export const SkeletonDetailGrid: React.FC<{ count?: number }> = ({ count = 4 }) => {
  const items = Array.from({ length: count });

  return (
    <div className="skeleton-detail-grid">
      {items.map((_, index) => (
        <div key={index} className="skeleton-detail-item">
          <SkeletonLoader type="text" width="40%" height="12px" />
          <SkeletonLoader type="text" width="100%" height="16px" />
        </div>
      ))}
    </div>
  );
};
